import React from 'react'
import { Route } from 'react-router-dom';
import { connect } from 'react-redux'

const ChildRoute = ({ exact, path, component, isPrivate, executionContext, userId }) => {
    let currentScope = null; //TODO: Sacar cuando se empiece a utilizar executionContext en las pantallas.
    let currentExecutionContext = null;
    let cantRoutes = null;
    let hash = location.hash;
    let validPath = null;

    let Component = component;
    let splitedPath = hash.split("/");

    if (splitedPath != undefined)
        cantRoutes = splitedPath.length;


    if (localStorage.getItem('executionContext') && localStorage.getItem('currentScope')) {
        executionContext = JSON.parse(localStorage.getItem('executionContext'));
        currentScope = JSON.parse(localStorage.getItem('currentScope'));
    }
    else
        //TODO: no se cargo el contexto de ejecucion correctamente en PORTICO
        console.log('no se guardo el contexto de ejecución');

    if (executionContext != null && executionContext != undefined) {

        currentExecutionContext = JSON.parse(JSON.stringify(executionContext));
        currentExecutionContext.ProductCode = (splitedPath[1] == undefined) ? null : splitedPath[1];
        currentExecutionContext.CategoryCode = (splitedPath[2] == undefined) ? null : splitedPath[2];
        currentExecutionContext.FeatureCode = null;
        currentExecutionContext.ProgramCode = (splitedPath[3] == undefined) ? null : splitedPath[3];
    }
    return (
        <Route exact={exact} path={path} render={props => <Component executionContext={currentExecutionContext} currentScope={currentScope} {...props} />} />
    );
}

const mapDispatchToProps = (dispatch, ownProps) => { }

const ConnectedChildRoute = connect(
    null,
    mapDispatchToProps
)(ChildRoute)

export default ConnectedChildRoute;
